<template>
    <form role="form" lpformnum="3" id="occasion_form" v-on:submit.prevent="submit">
        <div class="alert alert-danger" v-if="errors">
            An Event with Same Name and date already exists, please try searching for the event instead.
        </div>
        <div class="form-group" v-if="role=='admin'">
            <label>Calendar this belongs to</label>
            <select class="form-control"
                    v-model="occasion.calendar_id"
                    @change="getCalendar($event.target.value)">
                <option v-for="calendar in calendars" :value="calendar.id" :key="calendar.id">{{calendar.name}}</option>
            </select>
        </div>
        <div class="form-group">
            <label >Event Name</label>
            <input name="name" class="form-control" v-model="occasion.name" autocomplete="off" required="required">
        </div>
        <div class="form-group" v-if="!occasion.no_date">
            <label >Event Date</label>
            <date-picker v-model="occasion.date" :config="config" required="required"></date-picker>
        </div>
        <div class="row">
            <div class="col-md-12" v-if="showOccasionType">
                <div class="form-group">
                    <label >{{calendar.occasion_type_term}}</label>
                    <v-select v-model="occasion.occasion_type"
                              :options="occasionTypes"
                              label="name"
                              required="required">
                    </v-select>
                </div>
            </div>
            <div class="col-md-12" v-if="showOccasionTags">
                <div class="form-group">
                    <label >{{calendar.tag_term}}</label>
                    <v-select v-model="occasion.tag"
                              :options="tags">
                    </v-select>
                </div>
            </div>

            <div class="col-md-12" :class="boxClass.box" v-if="additionSchema.fields.length>0">
                <div :class="boxClass.boxBody">

                    <vue-form-generator

                        :schema="additionSchema"
                        :model="values"
                        :options="formOptions"
                        @validated="onValidated"
                        refs="vfg1">

                    </vue-form-generator>
                </div>
            </div>

        </div>
        <div>
            <button type="submit" :class="submitBtnClass" :disabled="disabledSubmit">
                {{submitBtnText}}
            </button>
        </div>

    </form>
</template>

<script>

    // Import this component
    import datePicker from 'vue-bootstrap-datetimepicker';
    import Ckeditor from 'vue-ckeditor2'
    import vSelect from 'vue-select'
    import VueFormGenerator from "vue-form-generator";

    export default {
        name: "occasion-popup-form",
        components: {datePicker, Ckeditor, vSelect},
        props: {
            calendarId: {
                type: Number,
                default: null,
                required: false
            },
            role: {
                type: String,
                default: 'user'
            },
            theme: {
                type: String,
                default: 'bs3'
            }
        },
        data() {
            return {
                calendar: {},
                errors: false,
                additionSchema: {
                    fields: []
                },
                occasion: {
                    calendar_id: null,
                    name: '',
                    description: '',
                    date: '',
                    no_date: '',
                    occasion_type: null,
                    tag: null,
                    capacity: '',
                    managed: false,
                    closing_date: '',
                    no_closing_date: '',
                    terms: '',
                },
                validated: false,
                values: {
                    position: '',
                    time: '',
                },
                formOptions: {
                    validateAfterLoad: false,
                    validateAfterChanged: true
                },
                calendars: [],
                occasionTypes: [],
                tags: [],
                ckConfig: {
                    toolbar: [
                        ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript']
                    ],
                    height: 300,
                    versionCheck: false,
                },
                ckTermsConfig: {
                    toolbar: [
                        ['Bold']
                    ],
                    height: 100,
                    versionCheck: false,
                },
                config: {
                    format: this.allowFuture ? 'DD/MM/YYYY H:mm' : 'DD/MM/YYYY',
                    useCurrent: false,
                    sideBySide: true,
                    maxDate: !this.allowFuture ? new moment() : false
                },
                closingDateConfig: {
                    format: 'DD/MM/YYYY H:mm',
                    useCurrent: false,
                    sideBySide: true,
                },
                submitting: false,
            }
        },
        created() {

            //Get the list of calendars
            this.getCalendars();

            //If we want to assign this to a specific calendar, set it now
            if (this.calendarId) {
                this.occasion.calendar_id = this.calendarId;
                this.getCalendar(this.occasion.calendar_id);
            }
        },
        watch: {
            // whenever question changes, this function will run
            dated: function (newDate, oldDate) {
                this.closingDateConfig.maxDate = moment(newDate, 'DD/MM/YYYY H:mm');
            },
            selectedOccasionType: function (occasionType) {
                //Not sure why this would be undefined, but it can be...
                if (occasionType !== undefined) {
                    this.getTags(occasionType);
                    this.getAdditions(occasionType)
                }
            }
        },
        computed: {
            boxClass() {
                if (this.theme == 'bs3') {
                    return {
                        box: 'panel panel-default',
                        boxHeader: 'panel-heading',
                        boxBody: 'panel-body',
                        noPadding: 'no-padding'
                    }

                } else if (this.theme == 'evt') {
                    return {
                        box: 'box box-default',
                        boxHeader: 'box-header with-border',
                        boxBody: 'box-body',
                        noPadding: 'no-padding'
                    }
                } else {
                    return {
                        box: 'card card-default',
                        boxHeader: 'card-header',
                        boxBody: 'card-body',
                        noPadding: 'px-0 py-0'
                    }
                }
            },
            modalLabel() {
                return this.modalId + 'Label';
            },
            submitBtnClass() {
                return ['btn', 'btn-success', 'btn-block'];
            },
            submitBtnText() {
                return this.submitting ? "Submitting.." : "Submit";
            },
            disabledSubmit() {
                return this.submitting;
            },

            showOccasionType() {
                return this.occasionTypes.length > 1
            },
            showOccasionTags() {
                return this.occasion.occasion_type !== null;
            },
            dated() {
                return this.occasion.date;
            },
            submitUrl() {
                return this.occasion.id ? ('/api/internal/occasions/' + this.occasion.id + '.json') : ('/api/internal/occasions.json');
            },
            submitMethod() {
                return this.occasion.id ? 'put' : 'post';
            },
            selectedOccasionType() {
                return this.occasion.occasion_type !== null ? this.occasion.occasion_type : null;
            }
        },

        methods: {
            onValidated(isValid) {
                this.validated = isValid;
            },
            getCalendars() {
                var self = this;
                axios.get('/api/internal/calendars.json', {
                    headers: {
                        'Accept': 'application/json'
                    }
                }).then(function (response) {
                    response.data.data.forEach(function (item) {
                        var option = new Object();
                        option.id = item.id;
                        option.name = item.name;
                        self.calendars.push(option);
                        if (item.prime == true) {
                            self.occasion.calendar_id = item.id;
                        }
                    });

                    console.log(self.calendars);

                    //If there is only 1 calendar, instantly select it
                    if (self.calendars.length == 1) {
                        self.occasion.calendar_id = self.calendars[0].id;
                        self.getCalendar(self.occasion.calendar_id);
                    }else{
                        self.getCalendar(self.occasion.calendar_id);
                    }
                })
            },
            getCalendar(calendarId) {
                var self = this;

                axios.get('/api/internal/calendars/view/' + this.occasion.calendar_id + '.json', {
                    headers: {
                        'Accept': 'application/json'
                    }
                }).then(function (response) {
                    self.calendar = response.data.data;
                    self.getOccasionTypes(calendarId);
                })
            },
            getOccasionTypes(calendarId) {
                var self = this;

                this.occasionTypes = [];

                axios.get('/api/internal/calendars-occasion-types.json?id=' + calendarId, {
                    headers: {
                        'Accept': 'application/json'
                    }
                }).then(function (response) {

                    response.data.data.forEach(function (item) {
                        var option = new Object();
                        option.id = item.occasion_type.id;
                        option.name = item.occasion_type.name;
                        self.occasionTypes.push(option);
                    });

                    //If there is only 1 occasion_type, instantly select it
                    if (self.occasionTypes.length == 1) {
                        self.occasion.occasion_type = self.occasionTypes[0];
                    }
                })
            },
            getTags(occasionType) {

                var self = this;

                this.tags = []; //Clear any tags so we can push the newly found ones

                //If there is no occasion type, ensure no tags are selected
                if (occasionType === null) {
                    this.occasion.tag = null
                    return;
                }

                //Look for any occasion_tgas which belong to this occasion_type
                axios.get('/api/internal/occasion_tags.json?occasion_type_id=' + occasionType.id, {
                    headers: {
                        'Accept': 'application/json'
                    }
                }).then(function (response) {

                    var tagsIds = [];

                    response.data.data.forEach(function (item) {
                        var option = new Object();
                        tagsIds.push(item.id);
                        option.id = item.id;
                        option.label = item.name;
                        self.tags.push(option);
                    });

                    //Find any occasion_tags which should be removed from the user selection
                    if (self.occasion.tag !== null && self.occasion.tag.hasOwnProperty('id')) {
                        if (tagsIds.indexOf(self.occasion.tag.id) === -1) {
                            self.occasion.tag = null;
                        }
                    }
                })
            },
            getAdditions(occasionType) {

                var self = this;

                self.additionSchema.fields = [];

                //If there is no occasion type, ensure no tags are selected
                if (occasionType === null) {
                    this.occasion.occasion_type.occasion_type_additions = null
                    return;
                }
                const regex = /(?:[01]\d|2[0123]):(?:[012345]\d):(?:[012345]\d)/gm;
                //Look for any occasion_tgas which belong to this occasion_type
                axios.get('/api/internal/occasion_type_additions.json?occasion_type_id=' + occasionType.id, {
                    headers: {
                        'Accept': 'application/json'
                    }
                }).then(function (response) {

                    let temp = [];
                    response.data.data.forEach(function (item) {
                        var formItem = {};
                        var multipleValues = [];

                        formItem.model = 'addition_' + item.addition.id;
                        formItem.label = item.addition.name;
                        formItem.type = item.addition.data_type.vue_form_generator_type;
                        formItem.inputType = item.addition.data_type.vue_form_generator_input_type;
                        formItem.required = item.mandatory;

                        //Todo - make this this exists
                        if (item.addition.data_type.vue_form_generator_type == "select") {
                            item.addition.addition_multiple_options.forEach(function (additionMultipleOption) {
                                multipleValues.push(additionMultipleOption);
                            });

                            formItem.values = multipleValues;
                            formItem.model = 'addition_' + item.addition.id + '_multiple';
                        }
                        if (item.addition.data_type.vue_form_generator_type == "mask") {
                            formItem.type = "cleave";
                            formItem.placeholder = "hh:mm:ss";
                            formItem.cleaveOptions = {
                                blocks: [2, 2, 2],
                                delimiters: [':', ':'],
                                numericOnly: true,
                                uppercase: false,
                                lowercase: false
                            };
                            formItem.pattern = regex;
                            formItem.validator = [VueFormGenerator.validators.regexp];
                        }

                        //hint: "Minimum 6 characters",
                        if (item.addition.data_type.vue_form_generator_validator) {
                            formItem.validator = item.addition.data_type.vue_form_generator_validator;
                        }
                        temp.push(formItem);
                    });
                    Vue.set(self.additionSchema, 'fields', temp)
                    console.log(self.additionSchema);
                })
            },
            submit() {

                var additionTypeValues = [];

                for (var key in this.values) {

                    //If this is not an additional_value continue
                    if (key.indexOf('_') <= 0) {
                        continue;
                    }

                    if (this.values.hasOwnProperty(key)) {
                        let parts = key.split("_");

                        //The ID of the addition
                        let additionId = parts[1];

                        //The value the user entered
                        let value = this.values[key];

                        //If its a fixed otpion input
                        if (parts.length == 3) {
                            //Multiple options
                            //A normal input
                            var additionTypeValue = {
                                'addition_id': additionId,
                                'addition_multiple_option_id': value,
                                'service_entity_id': this.occasion.occasion_type.id //To keep server validation happy
                            }
                        } else {
                            //A normal input
                            var additionTypeValue = {
                                'addition_id': additionId,
                                'value': value,
                                'service_entity_id': this.occasion.occasion_type.id //To keep server validation happy
                            }
                        }
                    }

                    additionTypeValues.push(additionTypeValue);
                }


                this.submitting = true;
                var self = this;
                self.errors = false;
                axios({
                    method: this.submitMethod,
                    url: this.submitUrl,
                    data: {
                        name: self.occasion.name,
                        date: self.allowFuture ? self.occasion.date : (self.occasion.date + " 00:00"),
                        no_date: self.occasion.no_date,
                        type: self.occasion.occasion_type,
                        tag: self.occasion.tag,
                        calendar_id: self.occasion.calendar_id,
                        closing_date: self.occasion.managed ? self.occasion.closing_date : null,
                        no_closing_date: self.occasion.no_closing_date,
                        managed: self.occasion.managed,
                        description: self.occasion.description,
                        terms: self.occasion.terms,
                        capacity: self.occasion.capacity,
                        additional_occasion_values: additionTypeValues,
                        allow_user_upload_results: true
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                }).then(function (response) {
                    self.complete(response.data.data);
                }).catch(function (error) {
                    self.errors = true;
                    self.submitting = false;
                });
            },
            complete(data) {
                this.$emit('occasionAdded', data);
            },
            onBlur(editor) {
                console.log(editor)
            },
            onFocus(editor) {
                console.log(editor)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .margin-top {
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/Assets/components/Occasions/Form/Popup.vue